import settings from '@/data/constants';

export const CALENDAR_SLOT_MIN_TIME = 7;
export const CALENDAR_SLOT_MAX_TIME = 21;
export const FLEX_CALENDAR_URL = `${settings.url}/nurse/flex-calendar`;

export type PaletteKey = 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
